/*
*
* This file is used to handle the product form submission. It does not handle image variant changes.
*
*/

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // this.cartNotification = document.querySelector('cart-notification');
      this.addToCartButton = document.querySelector('.product-form__submit');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      const originalButtonText = submitButton.innerText;
    
      if (submitButton.classList.contains('loading')) return;
    
      this.handleErrorMessage();
    
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    
      // Adding text to indicate adding to cart.
      submitButton.innerText = "Adding to cart...";
    
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
    
      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
    
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
    
          // If no error, change the text to indicate the item was added to cart.
          submitButton.innerHTML = "Added to cart &#10004;"; // HTML for checkmark symbol.
    
          // Set timeout to change the text back to original after 3 seconds.
          setTimeout(() => {
            submitButton.innerText = originalButtonText;
            // Remove focus from the button.
            submitButton.blur();
          }, 3000);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }
    
    

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
